import { render, staticRenderFns } from "./web-editor.vue?vue&type=template&id=c060b512&scoped=true"
import script from "./web-editor.vue?vue&type=script&lang=js"
export * from "./web-editor.vue?vue&type=script&lang=js"
import style0 from "./web-editor.vue?vue&type=style&index=0&id=c060b512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060b512",
  null
  
)

export default component.exports